export const exposes = [
  {
    id: 'variety-show-clip-edited',
    title: '某综艺「选手互撕」片段疯传，完整版还原后真相反转',
    summary:
      '一段剪辑过的综艺片段在多个平台疯传，看似选手当场翻脸。拿到未剪辑母带后，我们发现冲突来自两期节目拼接，中间的关键调解环节被剪掉了。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20torn%20film%20strips%20and%20scissors%20on%20warm%20cream%20paper%20background%20with%20vermillion%20red%20accents%2C%20textured%20cutout%20art%2C%20no%20text&width=800&height=600&seq=kanliao-variety-01&orientation=landscape',
    category: '网络传言',
    categorySlug: 'rumor',
    verdict: 'partial',
    credibility: 58,
    heat: 9860,
    publishedAt: '2026-09-10',
    updatedAt: '2026-09-12',
    readTime: '6 分钟',
    source: '短视频平台 · 多账号转发',
    tags: ['综艺剪辑', '拼接视频', '断章取义'],
    timeline: [
      { time: '09-10 20:14', title: '片段首次出现', detail: '一段 15 秒的综艺片段被多个娱乐账号同步转发，配文强调「现场翻脸」。' },
      { time: '09-11 09:30', title: '播放量破千万', detail: '片段冲上热搜，相关话题下出现大量站队与人身攻击言论。' },
      { time: '09-11 21:00', title: '节目组回应', detail: '节目组表示片段经过剪辑，将放出完整版本以正视听。' },
      { time: '09-12 14:20', title: '完整版核对', detail: '本站在完整素材中确认冲突分属两期，中间存在一次已播出的调解。' },
    ],
    evidence: [
      { title: '未剪辑素材时间轴', detail: '完整素材显示两个画面之间相隔约 40 分钟，并非连续发生。', status: 'solid' },
      { title: '当事人后续互动', detail: '两位当事人在后续节目中同桌游戏，语气轻松，与「翻脸」叙述不符。', status: 'solid' },
      { title: '网传配文截图', detail: '最早发布账号已删除配文，且账号历史存在多次搬运未核实内容的情况。', status: 'weak' },
    ],
    analysis: [
      '这条料的传播路径很典型：先由几个涨粉账号同步投放一段极短的视频，配上一句情绪化的话，然后在两小时内被更大体量的账号接手，形成「全网都在讨论」的错觉。',
      '真正让判断成立或推翻的，是那段被剪掉的中间环节。完整素材里，两位当事人之间有一次已经播出的调解，冲突和调解分属两期，被剪在一起后就成了「当场翻脸」。',
    ],
    conclusion: '「互撕」确有其事，但被剪辑放大：冲突真实存在，却被拼接成即时发生的场面。建议把这条料当作「部分属实、情绪失真」来看。',
    hot: true,
    featured: true,
    relatedIds: ['singer-endorsement-fee', 'livestream-script-leak'],
  },
  {
    id: 'singer-endorsement-fee',
    title: '网传歌手「天价代言费」截图流出，数字对不上合同口径',
    summary:
      '一张标注了七位数代言费的聊天截图在群里流转，配文称「品牌方已被掏空」。我们比对了公开工商信息与多方说法后，发现截图中的数字与公开报价口径并不一致。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20a%20paper%20contract%20with%20a%20magnifying%20glass%20over%20warm%20cream%20paper%20texture%20with%20amber%20and%20red%20accents%2C%20cutout%20art%20style%2C%20no%20text&width=800&height=600&seq=kanliao-endorse-02&orientation=landscape',
    category: '商界传闻',
    categorySlug: 'business',
    verdict: 'debunked',
    credibility: 22,
    heat: 6420,
    publishedAt: '2026-09-08',
    updatedAt: '2026-09-11',
    readTime: '5 分钟',
    source: '聊天群 · 匿名截图',
    tags: ['代言费', '聊天截图', '数字存疑'],
    timeline: [
      { time: '09-08 11:02', title: '截图开始流传', detail: '一张聊天截图在多个粉丝群出现，标注七位数报价。' },
      { time: '09-09 15:40', title: '品牌方侧面回应', detail: '品牌方在公开沟通中表示合作仍在洽谈，未进入报价确认阶段。' },
      { time: '09-11 10:15', title: '口径比对', detail: '本站比对公开报价区间，截图数字明显高于行业常见档位。' },
    ],
    evidence: [
      { title: '截图字体与排版异常', detail: '截图中的时间戳间距不均匀，存在后期修改痕迹的常见特征。', status: 'weak' },
      { title: '品牌方公开口径', detail: '品牌方表示合作仍处于意向阶段，尚未确认任何费用金额。', status: 'solid' },
      { title: '行业报价区间', detail: '同类合作公开报价区间与截图数字相差较大，缺乏可比支撑。', status: 'weak' },
    ],
    analysis: [
      '涉及金额的爆料最容易失真，因为数字本身极具冲击力，传播者往往不会去核对口径。判断这类料，第一步就是看数字有没有可验证的来源。',
      '这条料的数字既没有合同、也没有财务口径支撑，唯一的依据是一张来历不明的聊天截图，而截图本身还有明显的修改特征。',
    ],
    conclusion: '目前没有任何可靠证据支撑该代言费数字，判定为「已辟谣」。遇到带精确金额的截图，先问一句：这个数字从哪来的。',
    hot: false,
    relatedIds: ['variety-show-clip-edited', 'brand-recall-rumor'],
  },
  {
    id: 'livestream-script-leak',
    title: '「直播脚本泄露」文档流出，其实是份通用话术模板',
    summary:
      '一份标题写着某头部主播名称的脚本文档被当成「割韭菜实锤」传播。打开后我们发现，这正是行业内最常见的通用直播话术模板，与特定主播并无绑定。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20a%20notebook%20of%20speaking%20notes%20and%20a%20microphone%20on%20warm%20cream%20paper%20background%20with%20olive%20green%20and%20red%20accents%2C%20cutout%20art%2C%20no%20text&width=800&height=600&seq=kanliao-live-03&orientation=landscape',
    category: '商界传闻',
    categorySlug: 'business',
    verdict: 'partial',
    credibility: 64,
    heat: 5310,
    publishedAt: '2026-09-06',
    updatedAt: '2026-09-09',
    readTime: '5 分钟',
    source: '网盘文件 · 多个群转发',
    tags: ['直播话术', '脚本泄露', '行业模板'],
    timeline: [
      { time: '09-06 13:20', title: '文档流出', detail: '一份标有主播名称的脚本文档被上传到网盘并广泛转发。' },
      { time: '09-07 18:00', title: '模板比对', detail: '本站检索到多份高度相似的公开话术模板，措辞几乎一致。' },
      { time: '09-09 09:10', title: '团队回应', detail: '相关团队表示文档名称系人为添加，内容为行业通用模板。' },
    ],
    evidence: [
      { title: '通用模板对照', detail: '文档主体与公开流传的行业话术模板重合度极高，缺少专属信息。', status: 'solid' },
      { title: '文档属性信息', detail: '文档创建者信息被清空，无法证明与特定主播的归属关系。', status: 'weak' },
      { title: '团队说明', detail: '团队公开回应称文件名由第三方添加，非内部正式文档。', status: 'solid' },
    ],
    analysis: [
      '「脚本」两个字本身就自带流量，很多人看到标题就默认内容劲爆。但一份文档能不能作为实锤，取决于它是否与该对象真实绑定。',
      '这份文档的核心内容在多个公开渠道都能找到几乎相同的版本，真正属于「专属」的部分只有被手动改过的文件名。',
    ],
    conclusion: '话术模板确实存在且行业内普遍使用，但把它说成某位主播的独家内部脚本，属于夸大。判定为「部分属实」。',
    relatedIds: ['variety-show-clip-edited', 'singer-endorsement-fee'],
  },
  {
    id: 'celebrity-split-photo',
    title: '某艺人与搭档「已分手」照片疯传，拍摄时间被误读',
    summary:
      '一组两人不再同行的偷拍照被解读为感情生变。核对照片的拍摄时间与行程后发现，照片拍摄于一次工作行程调整，与感情状况无关。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20candid%20photographs%20with%20a%20date%20stamp%20on%20warm%20cream%20paper%20texture%20with%20soft%20olive%20and%20red%20accents%2C%20cutout%20art%2C%20no%20text&width=800&height=600&seq=kanliao-photo-04&orientation=landscape',
    category: '娱乐圈料',
    categorySlug: 'entertainment',
    verdict: 'debunked',
    credibility: 18,
    heat: 8740,
    publishedAt: '2026-09-05',
    updatedAt: '2026-09-07',
    readTime: '4 分钟',
    source: '娱乐账号 · 随手拍',
    tags: ['偷拍照片', '时间误读', '感情传闻'],
    timeline: [
      { time: '09-05 22:40', title: '照片发布', detail: '一组同行照片被配文「疑似生变」，迅速登上话题榜。' },
      { time: '09-06 12:00', title: '时间核对', detail: '照片 EXIF 与公开行程显示拍摄于数周前的一次工作安排。' },
      { time: '09-07 16:30', title: '辟谣', detail: '相关方澄清当天为工作行程调整，与感情状况无关。' },
    ],
    evidence: [
      { title: '照片拍摄时间', detail: '图片元数据显示拍摄时间早于爆料发布数周，属旧图新用。', status: 'solid' },
      { title: '公开行程对照', detail: '当天两人分别有公开工作安排，早于爆料时间线。', status: 'solid' },
      { title: '爆料账号历史', detail: '该账号多次以旧图翻炒同类话题，可信度过往记录较差。', status: 'weak' },
    ],
    analysis: [
      '情感类爆料最常见的手法就是「旧图新用」：把很久以前的一张普通照片，配上一个当下流行的叙事，再选择合适的时机发布。',
      '这类料的破解方式其实很朴素——查照片是什么时候拍的。时间对不上，整个叙事就不成立了。',
    ],
    conclusion: '照片真实，但被嫁接到错误的叙事上，判定为「已辟谣」。看到情感类偷拍图，先看拍摄时间。',
    hot: true,
    relatedIds: ['variety-show-clip-edited', 'hidden-marriage-rumor'],
  },
  {
    id: 'brand-recall-rumor',
    title: '「某品牌产品被召回」通知刷屏，官方系统查无此记录',
    summary:
      '一条格式看起来相当正规的召回通知在社群传播，称某批次产品存在隐患。我们在官方渠道与行业通报中未检索到对应记录，通知本身存在多处格式疑点。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20a%20stack%20of%20official%20notices%20with%20a%20warning%20stamp%20on%20warm%20cream%20paper%20with%20amber%20and%20red%20accents%2C%20cutout%20art%2C%20no%20text&width=800&height=600&seq=kanliao-recall-05&orientation=landscape',
    category: '网络传言',
    categorySlug: 'rumor',
    verdict: 'debunked',
    credibility: 15,
    heat: 4180,
    publishedAt: '2026-09-04',
    updatedAt: '2026-09-06',
    readTime: '4 分钟',
    source: '社群转发 · 图文成品通知',
    tags: ['召回通知', '格式仿冒', '官方查无'],
    timeline: [
      { time: '09-04 08:30', title: '通知扩散', detail: '一张格式正规的召回通知在家庭群与母婴群大量转发。' },
      { time: '09-05 11:00', title: '官方检索', detail: '官方公示与行业通报渠道均未检索到对应召回记录。' },
      { time: '09-06 10:20', title: '格式疑点', detail: '通知中的编号规则与官方格式不符，联系方式指向私人账号。' },
    ],
    evidence: [
      { title: '官方公示检索', detail: '在公开召回公示中未找到该通知所提及的产品与批次。', status: 'solid' },
      { title: '编号与格式', detail: '通知编号不符合官方编制规则，多处以私人联系方式替代官方渠道。', status: 'solid' },
      { title: '网传源头', detail: '无法追溯到最初发布者，群聊中记录已被多次覆盖。', status: 'weak' },
    ],
    analysis: [
      '冒用「召回通知」是制造焦虑的常见套路：格式做得越像官方文件，转发的人越不敢质疑，宁可信其有。',
      '验证方式很直接——去官方公示渠道搜一次。真正的召回一定有可检索的编号与源头，查不到的多半有问题。',
    ],
    conclusion: '该召回通知查无实据，编号与格式均不符合官方规范，判定为「已辟谣」。收到类似通知，先到官方渠道核一次编号。',
    relatedIds: ['fake-weather-alert', 'singer-endorsement-fee'],
  },
  {
    id: 'tech-giant-layoff',
    title: '「科技大厂裁员 40%」传闻发酵，比例与实际情况差距明显',
    summary:
      '一则裁员传闻在职场社区刷屏，称某业务线裁员比例高达四成。综合多方职级信息与公开调整动作，实际涉及范围远小于传闻数字。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20an%20office%20building%20made%20of%20paper%20cutouts%20with%20a%20descending%20chart%20on%20warm%20cream%20background%20with%20olive%20and%20red%20accents%2C%20no%20text&width=800&height=600&seq=kanliao-layoff-06&orientation=landscape',
    category: '科技圈',
    categorySlug: 'tech',
    verdict: 'partial',
    credibility: 55,
    heat: 7230,
    publishedAt: '2026-09-03',
    updatedAt: '2026-09-08',
    readTime: '6 分钟',
    source: '职场社区 · 匿名帖',
    tags: ['裁员传闻', '比例夸大', '组织调整'],
    timeline: [
      { time: '09-03 21:00', title: '匿名帖发布', detail: '职场社区出现「业务线裁员 40%」的帖子，配以部分截图。' },
      { time: '09-04 14:00', title: '多方交叉', detail: '多位在职员工给出的信息显示调整范围集中在中后台部分岗位。' },
      { time: '09-08 10:00', title: '公开信息对照', detail: '公开组织调整动作与传闻比例存在明显出入。' },
    ],
    evidence: [
      { title: '在职员工描述', detail: '多位员工反馈调整以岗位优化为主，涉及比例远低于传闻数字。', status: 'solid' },
      { title: '匿名帖截图', detail: '截图未显示具体团队与人数，无法支撑 40% 的比例。', status: 'weak' },
      { title: '公开调整动作', detail: '公开信息显示为局部组织调整，未见整条业务线大幅收缩。', status: 'solid' },
    ],
    analysis: [
      '职场类传闻的特点是具体数字很多，但可核对的很少。比例越大越容易被记住，也越容易在转述中被继续放大。',
      '本次调整确实存在，问题出在范围与比例的表述上：把局部岗位优化说成整条业务线的大规模裁员，是典型的以偏概全。',
    ],
    conclusion: '组织调整属实，但「40% 裁员」的说法缺乏支撑，判定为「部分属实」。看职场传闻，重点关注涉及范围而非单一比例。',
    relatedIds: ['singer-endorsement-fee', 'livestream-script-leak'],
  },
  {
    id: 'fake-weather-alert',
    title: '「特大暴雨预警」红头文件流传，气象部门回应为拼接图',
    summary:
      '一张带有预警信号的「红头文件」在本地群被大量转发，落款看似来自权威机构。气象部门回应称该文件为拼接伪造，真正的预警会通过官方渠道统一发布。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20storm%20clouds%20and%20a%20paper%20document%20on%20warm%20cream%20paper%20with%20muted%20red%20and%20olive%20accents%2C%20cutout%20art%2C%20no%20text&width=800&height=600&seq=kanliao-weather-07&orientation=landscape',
    category: '社会热点',
    categorySlug: 'society',
    verdict: 'debunked',
    credibility: 12,
    heat: 9100,
    publishedAt: '2026-09-02',
    updatedAt: '2026-09-02',
    readTime: '4 分钟',
    source: '本地社群 · 拼接文件',
    tags: ['天气预警', '拼接伪造', '官方回应'],
    timeline: [
      { time: '09-02 07:10', title: '文件扩散', detail: '一张带预警信号的「红头文件」在本地群快速转发。' },
      { time: '09-02 10:40', title: '官方回应', detail: '气象部门表示未发布该文件，提醒以官方渠道信息为准。' },
      { time: '09-02 15:00', title: '拼接痕迹分析', detail: '文件印章与正文排版错位，属两张图叠加的常见特征。' },
    ],
    evidence: [
      { title: '官方渠道核对', detail: '官方预警发布渠道未出现该文件所标注的预警等级与时段。', status: 'solid' },
      { title: '印章排版错位', detail: '印章位置与正文基线明显错位，存在图像拼接痕迹。', status: 'solid' },
      { title: '转发源头', detail: '最早转发的账号未说明来源，后续均为复制粘贴。', status: 'weak' },
    ],
    analysis: [
      '天气类谣言传播极快，因为它关系到每个人的出行安全，理性判断会被「宁可信其有」压过去。',
      '这类文件的辨别重点在于来源：真正的预警一定会通过官方渠道发布，能否在官方渠道查到，是第一道也是最重要的一道关卡。',
    ],
    conclusion: '该预警文件系拼接伪造，判定为「已辟谣」。极端天气信息请以官方发布为准。',
    hot: true,
    relatedIds: ['brand-recall-rumor', 'variety-show-clip-edited'],
  },
  {
    id: 'hidden-marriage-rumor',
    title: '「已领证」爆料持续两年，至今没有任何可核实的登记线索',
    summary:
      '一条关于艺人「已领证」的爆料反复出现，每隔几个月就会更新一次细节。两年来始终没有出现任何可核实的登记或公开佐证，属于典型的长期悬案。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20two%20paper%20rings%20and%20a%20question%20mark%20on%20warm%20cream%20paper%20texture%20with%20soft%20amber%20and%20red%20accents%2C%20cutout%20art%2C%20no%20text&width=800&height=600&seq=kanliao-marriage-08&orientation=landscape',
    category: '娱乐圈料',
    categorySlug: 'entertainment',
    verdict: 'pending',
    credibility: 35,
    heat: 4680,
    publishedAt: '2026-08-28',
    updatedAt: '2026-09-10',
    readTime: '5 分钟',
    source: '娱乐账号 · 长期跟进',
    tags: ['领证传闻', '长期悬案', '无实据'],
    timeline: [
      { time: '2024-11', title: '首次出现', detail: '有账号称两人已低调领证，未提供任何依据。' },
      { time: '2026-06', title: '细节更新', detail: '新的说法加入了「时间与地点」，仍未出现可核对材料。' },
      { time: '2026-09-10', title: '持续核实', detail: '多次尝试均未找到可核实的登记线索，当事方未回应。' },
    ],
    evidence: [
      { title: '登记线索核查', detail: '未检索到任何可核对的公开登记或佐证材料。', status: 'weak' },
      { title: '爆料版本变动', detail: '每次更新都会修改细节，自相矛盾之处较多。', status: 'weak' },
      { title: '当事方未回应', detail: '双方均未就该传闻作出正式回应，无法佐证或否认。', status: 'weak' },
    ],
    analysis: [
      '有些爆料之所以能一直存在，正是因为它永远无法被证实，也无法被彻底推翻——留白本身就是它的生存空间。',
      '这份爆料两年来更新了多个版本，每次细节都不同，这恰恰说明源头并不掌握可核实的信息。',
    ],
    conclusion: '当前证据不足以支持或否定该说法，判定为「仍在核实」。在没有可靠依据前，建议保持观望，不要当作事实转述。',
    relatedIds: ['celebrity-split-photo', 'variety-show-clip-edited'],
  },
  {
    id: 'campus-food-event',
    title: '「食堂食材问题」视频引发关注，后续检测结果已公开',
    summary:
      '一段拍摄于校园食堂后厨的视频引发广泛关注。事件后续已完成抽样检测并公开结果，多个传言在检测数据公布后得到澄清。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20a%20bowl%20and%20a%20clipboard%20checklist%20on%20warm%20cream%20paper%20with%20olive%20green%20and%20red%20accents%2C%20cutout%20art%2C%20no%20text&width=800&height=600&seq=kanliao-campus-09&orientation=landscape',
    category: '社会热点',
    categorySlug: 'society',
    verdict: 'confirmed',
    credibility: 88,
    heat: 7740,
    publishedAt: '2026-08-30',
    updatedAt: '2026-09-05',
    readTime: '5 分钟',
    source: '校园社群 · 现场视频',
    tags: ['校园食堂', '检测结果', '后续处理'],
    timeline: [
      { time: '08-30 12:00', title: '视频出现', detail: '一段后厨视频在校园社群传播，引发大量讨论。' },
      { time: '09-01 10:00', title: '介入与抽检', detail: '相关部门介入并对相关批次进行抽样检测。' },
      { time: '09-05 16:00', title: '结果公开', detail: '检测结果与处理情况对外公开，多项传言被逐条回应。' },
    ],
    evidence: [
      { title: '现场视频', detail: '视频拍摄环境与地点可对应，画面内容与后续说明基本一致。', status: 'solid' },
      { title: '抽样检测结果', detail: '官方公开的检测数据与处理说明，构成主要依据。', status: 'solid' },
      { title: '后续整改动作', detail: '相关方公布了整改措施与时间安排。', status: 'solid' },
    ],
    analysis: [
      '这是一条证据链相对完整的爆料：从现场视频，到抽样检测，再到结果公开，每个环节都有可核对的依据。',
      '值得注意的是，事件本身属实，但传播过程中仍夹杂了不少夸大说法，这些部分在检测结果公布后被逐条澄清。',
    ],
    conclusion: '核心事实成立，后续处理与检测结果均已公开，判定为「实锤成立」。这是爆料核实中证据链较完整的正面案例。',
    relatedIds: ['fake-weather-alert', 'brand-recall-rumor'],
  },
  {
    id: 'influencer-number-inflate',
    title: '合作方爆料「数据灌水」，第三方榜单与说法互相印证',
    summary:
      '一位合作方公开表示某账号的互动数据存在异常。第三方榜单的历史曲线与说法形成呼应，但具体灌水比例无法准确量化。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20collage%20illustration%20of%20a%20rising%20bar%20chart%20with%20paper%20arrows%20on%20warm%20cream%20paper%20texture%20with%20amber%20and%20red%20accents%2C%20cutout%20art%2C%20no%20text&width=800&height=600&seq=kanliao-data-10&orientation=landscape',
    category: '商界传闻',
    categorySlug: 'business',
    verdict: 'confirmed',
    credibility: 82,
    heat: 5560,
    publishedAt: '2026-08-26',
    updatedAt: '2026-09-01',
    readTime: '5 分钟',
    source: '合作方公开发言 · 第三方榜单',
    tags: ['数据异常', '合作方爆料', '榜单印证'],
    timeline: [
      { time: '08-26 15:00', title: '合作方发声', detail: '合作方公开表示投放数据与互动表现存在明显落差。' },
      { time: '08-28 09:00', title: '榜单曲线比对', detail: '第三方榜单显示该账号互动曲线存在多次异常陡增。' },
      { time: '09-01 11:00', title: '综合判断', detail: '多条线索互相印证，但具体比例仍无法精确量化。' },
    ],
    evidence: [
      { title: '合作方投放数据', detail: '合作方公开了投放后转化与实际互动的对比数据。', status: 'solid' },
      { title: '第三方榜单曲线', detail: '历史互动曲线存在多次异常陡增，与自然增长特征不符。', status: 'solid' },
      { title: '具体灌水比例', detail: '无法获得后台原始数据，比例只能估算。', status: 'weak' },
    ],
    analysis: [
      '数据类爆料最怕「只有情绪没有曲线」。这次之所以能形成判断，是因为合作方数据与第三方榜单两条独立线索指向了同一个方向。',
      '需要说明的是，方向可以确认，但比例无法精确。所以这条料适合作为参考，不适合当作精确结论引用。',
    ],
    conclusion: '数据异常有两条独立线索支撑，判定为「实锤成立」；但具体灌水比例无法量化，引用时请注意表述边界。',
    relatedIds: ['tech-giant-layoff', 'singer-endorsement-fee'],
  },
];

export const featuredId = 'variety-show-clip-edited';

export const categoryInfos = [
  { name: '娱乐圈料', slug: 'entertainment', desc: '情感、合作、行程类爆料核实', icon: 'ri-movie-2-line', count: 2 },
  { name: '商界传闻', slug: 'business', desc: '报价、数据、合作类传闻核实', icon: 'ri-line-chart-line', count: 3 },
  { name: '网络传言', slug: 'rumor', desc: '截图、通知、拼接图文核实', icon: 'ri-chat-3-line', count: 2 },
  { name: '科技圈', slug: 'tech', desc: '组织调整与行业动态核实', icon: 'ri-cpu-line', count: 1 },
  { name: '社会热点', slug: 'society', desc: '公共事件与生活传言核实', icon: 'ri-community-line', count: 2 },
];

export const debunkedIds = ['singer-endorsement-fee', 'celebrity-split-photo', 'brand-recall-rumor', 'fake-weather-alert'];